'use client';

import dynamic from 'next/dynamic';

export const DynamicWebAnalyticsScript = dynamic(
  () => import('../scripts/WebAnalyticsScript').then((mod) => mod.default),
  {
    ssr: false,
  }
);

export const DynamicSplunkRumScript = dynamic(
  () => import('../scripts/SplunkRumScript').then((mod) => mod.default),
  {
    ssr: false,
  }
);

export const DynamicUdlScript = dynamic(
  () => import('../scripts/UdlScript').then((mod) => mod.default),
  {
    ssr: false,
  }
);
